module.exports = __webpack_public_path__ + "ee65794e3ec1a0ce6857fc1248e1b70f.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img3.png
// module id = 1322
// module chunks = 0